import { ref } from 'vue';
import { debounce, startCase, upperFirst } from 'lodash';

export const convertToTitleCase = (str) => {
  if (!str) return '';

  var words = str.split('_');
  words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase();

  for (var i = 1; i < words.length; i++) {
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
  }

  var result = words.join(' ');

  return result;
}

export const stringToArray = (idsString) => {
  return idsString.split(',').map(Number);
}

export const groupBy = (array, key) => {
  return array.reduce((result, currentValue) => {
    (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
    return result;
  }, {});
}

export const pluck = (array, key) => {
  return array.map(item => item[key]);
}

export const replaceDashWithUnderscore = (str) => {
  if(!str) return "";
  return str.replace(/-/g, "_");
}

export const replaceDashWithSpace = (str, textTransform = null) => {
  if(!str) return "";
  let formattedTxt = str.replace(/-/g, " ");

  if(textTransform === 'capitalized'){
    formattedTxt = startCase(formattedTxt);
  }

  return formattedTxt;
}

export const joinArrayOfString = (texts) => {

  if (!texts.length) return '';

  let joinedString = '';

  if (texts.length > 1) {
      joinedString = texts.slice(0, -1).join(', ') + ' and ' + texts.slice(-1);
      return joinedString;
  } 

  joinedString = texts[0];

  return joinedString;
}

export const getCurrentFormattedDateTime = () => { // 2023-12-19 11:39:43 PM
    const currentDate = new Date();

    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');

    let hours = currentDate.getHours();
    const minutes = String(currentDate.getMinutes()).padStart(2, '0');
    const seconds = String(currentDate.getSeconds()).padStart(2, '0');
    const meridiem = hours >= 12 ? 'PM' : 'AM';
  
    hours = hours % 12 || 12;

    const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${meridiem}`;
  
    return formattedDateTime;
}

export const toCapitalizeFirst = (value) => {
  if (!value) return '';
  return upperFirst(value.toLowerCase());
}

export const formatDate = (date) => {
  var formattedDate = date.toISOString().split('T')[0];
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var amOrPm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  var formattedTime = hours + ':' + (minutes < 10 ? '0' : '') + minutes + ' ' + amOrPm;

  return formatToDdMmYy(formattedDate) + ' ' + formattedTime
}

export const formatRawDate = (date) => {
  if (!date) return '';
  return formatDate(new Date(date));
}

export const chunkArray = (array, chunkSize) => {
  let resultArray = [];
  
  for (let i = 0; i < array.length; i += chunkSize) {
    let chunk = array.slice(i, i + chunkSize);
    resultArray.push(chunk);
  }

  return resultArray;
}

export const formatToDdMmYy = (date) => {
  var dat = date.split('-');
  return `${dat[2]}-${dat[1]}-${dat[0]}`;
}

export const formatDateToDdMmYy = (date) => {  // Output: "18/09/2023"
  if(!date) return '';

  var parsedDate = new Date(date);
  var formattedDate = ("0" + parsedDate.getDate()).slice(-2) + "/" + ("0" + (parsedDate.getMonth() + 1)).slice(-2) + "/" + parsedDate.getFullYear();
  return formattedDate;
}


export const checkNullAndFormatValue = (text) => {
  if (!text) return '';
  if (text === 'null') return '';
  return text;
}

export const removeAbnormalDate = (date) => {
  if (!date) return '';
  if (date == '0000-00-00') {
    return '';
  }
  return date;
}

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 0
  }).format(value);
}

export const formatCurrency2D = (value) => {
  return new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value || 0);
}

export const formatToDdMmYySlash = (date) => {
  if (!date) return '';
  const dat = date.split('-');
  return `${dat[2]}/${dat[1]}/${dat[0]}`;
}

export const formatDateSlash = (date) => {
  const formattedDate = date.toISOString().split('T')[0];
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const amOrPm = hours >= 12 ? 'PM' : 'AM';
  return formatToDdMmYySlash(formattedDate) + ' ' + (hours % 12 || 12) + ':' + (minutes < 10 ? '0' : '') + minutes + ' ' + amOrPm;
}

export const commaFormat = (value) => {
  if (!value) {
    return 0.00
  }

  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'BDT' }).format(value).replace('BDT', '').trim()
}

export const generateUUID = () => {  // Output: "f47ac10b-58cc-4372-a567-0e02b2c3d479"
  const cryptoObj = window.crypto || window.msCrypto;
  const array = new Uint8Array(16);
  cryptoObj.getRandomValues(array);
  const uuid = array.reduce((acc, value, index) => {
    if (index === 4 || index === 6 || index === 8 || index === 10) {
      return acc + '-';
    }
    const str = value.toString(16).padStart(2, '0');
    return acc + str;
  }, '');
  return uuid;
}

export const formatNumberToTwoDecimals = (value) => {
  return Math.floor(value * 100) / 100;
} 

export const getCurrentDateTime = (date = null, adjustments = { hours: 0, minutes: 0, days: 0 }) => {
  const { hours = 0, minutes = 0, days = 0 } = adjustments;
  
  const currentData = date ? new Date(date) : Date.now();
  const offset = new Date().getTimezoneOffset();
  const localDate = new Date(currentData - offset * 60000);
  
  localDate.setDate(localDate.getDate() + days);
  localDate.setHours(localDate.getHours() + hours);
  localDate.setMinutes(localDate.getMinutes() + minutes);
  
  return localDate.toISOString().slice(0, 16);
};

export const json_string = (value) => {
  return JSON.stringify(value);
} 

export const json_parse = (value) => {
  return JSON.parse(value);
} 

export const json_string_parse = (value) => {
  return json_parse(json_string(value));
} 

  // date of barth convert to age
export const dateOfBirthConvertToAge = (birthday) => {
    const birthDateObj = new Date(birthday);
    const currentDate = new Date();
    const timeDifference = currentDate - birthDateObj;
    const year = Math.floor(timeDifference / (365.25 * 24 * 60 * 60 * 1000));
    const month = Math.floor(
        (timeDifference % (365.25 * 24 * 60 * 60 * 1000)) / (30.44 * 24 * 60 * 60 * 1000)
    );
    const day = Math.floor(
        (timeDifference % (30.44 * 24 * 60 * 60 * 1000)) / (24 * 60 * 60 * 1000)
    );
    return {year, month, day}
}

// format item title with details for print
export const getProductParticulars = (hasItemDetail, item) => {
  if(hasItemDetail) {
    return item.product.name +
      (!item.description ? "" : `\n${item.description}`) +
      (!item.batch_number ? "" : `\n${item.batch_number}`)
  }

  return item.head.name
}


export const useDebouncedSearch = (searchFunction, delay = 300) => {
  // Create a ref for the search query
  const searchQuery = ref('');

  // Create a debounced version of the search function
  const debouncedSearch = debounce(searchFunction, delay);

  // Watch for changes in the searchQuery and call the debounced function
  const handleSearch = () => {
    debouncedSearch();
  };


  return {
    handleSearch,
  };
}

export const addBaseUrl = (url) => {
  const formattedUrl = url.replace(/^\/|\/$/g, '');
  return `${process.env.VUE_APP_BASE_URL}/${formattedUrl}`;
}

export const addFrontBaseUrl = (url) => {
  const formattedUrl = url.replace(/^\/|\/$/g, '');
  return `${window.location.origin}/${formattedUrl}`;
}

export const handleAttachments = (formData, attachments) =>  {
  const previousFileIds = attachments
      .filter(attachment => typeof attachment === 'object' && attachment.hasOwnProperty('id'))
      .map(attachment => attachment.id);

  attachments.forEach((attachment, index) => {
    if (typeof attachment !== 'object' || !attachment.hasOwnProperty('id')) {
      formData.append(`attachments[${index}]`, attachment);
    }
  });

  if (previousFileIds.length) {
    formData.append('previous_file_ids', JSON.stringify(previousFileIds));
  }
}

export const formatDateTime = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const mi = String(date.getMinutes()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}T${hh}:${mi}`;
};

export const formatDayToDateReadable = (date) => {
    return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        timeZone: "UTC"
    });
}

export const formatDateToDay = (date) => {
    return date.toLocaleDateString("en-US", { weekday: "short" });
}

export const formatISODate = (date) => {
    return date.toISOString().split("T")[0];
}

export const getStartOfWeek = (date) => {
    const d = new Date(date);
    const day = d.getDay();
    const diff = d.getDate() - day + (day === 0 ? -6 : 1);
    return new Date(d.setDate(diff));
}

export const addDays = (date, days) => {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
}

export const taskStatusColors = {
    'completed': { bg: '#bbf7d0', border: '#22c55e', text: '#166534' },
    'approved':  { bg: '#d1fae5', border: '#10b981', text: '#065f46' },
    'overdue':   { bg: '#fecaca', border: '#ef4444', text: '#7f1d1d' },
    'today':     { bg: '#fde68a', border: '#f59e0b', text: '#78350f' },
    'active':    { bg: '#e0e7ff', border: '#6366f1', text: '#312e81' }
};

export const chartColorPalette = [
    '#4CAF50',
    '#2196F3',
    '#FFC107',
    '#F44336',
    '#9C27B0',
    '#00BCD4',
    '#8BC34A',
    '#FF9800',
    '#3F51B5',
    '#E91E63',
    '#795548',
    '#009688',
    '#CDDC39',
    '#673AB7',
    '#FF5722',
    '#607D8B',
    '#C2185B',
    '#1E88E5',
    '#43A047',
    '#FDD835'
]

/**
 * Parse image result with prefix format
 * Handles: "^Image^BMP^Base64^[base64data]"
 */
const parseBase64ImageResult = (result) => {
    if (!result || typeof result !== 'string') {
        return { base64: '', format: 'bmp' };
    }

    let base64Data = result;
    let format = 'bmp';

    if (result.startsWith('^Image^')) {
        const matches = result.match(
            /\^Image\^([A-Z0-9]+)\^Base64\^([\s\S]+)/i
        );

        if (matches.length === 3) {
            format = matches[1].toLowerCase();
            base64Data = matches[2];
        }
    }

    if (format === 'jpg') format = 'jpeg';

    return { base64: base64Data.trim(), format };
};


/**
 * Get proper data URI for image
 */
export const getBase64ImageDataUri = (result) => {
    const { base64, format } = parseBase64ImageResult(result);

    if (!base64) return '';
    if (base64.startsWith('data:image')) return base64;

    return `data:image/${format};base64,${base64}`;
};

/**
 * Add commas to a number string
 */
export const addCommas = (numStr) => {
    if (!numStr) return numStr;

    const parts = numStr.toString().split('.');
    let integerPart = parts[0];
    const decimalPart = parts[1];

    const lastThree = integerPart.slice(-3);
    const otherNumbers = integerPart.slice(0, -3);

    if (otherNumbers !== '') {
        integerPart =
            otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') +
            ',' +
            lastThree;
    }

    return decimalPart !== undefined
        ? `${integerPart}.${decimalPart}`
        : integerPart;
};

export const convertSuperscriptToHtml = (text) => {
    if (!text) return text;
    const superscriptMap = {
        '⁰': '0', '¹': '1', '²': '2', '³': '3', '⁴': '4',
        '⁵': '5', '⁶': '6', '⁷': '7', '⁸': '8', '⁹': '9',
        '⁻': '-', '⁺': '+'
    };

    return text.replace(/([⁰¹²³⁴⁵⁶⁷⁸⁹⁻⁺]+)/g, (match) => {
        const converted = match.split('').map(char => superscriptMap[char] || char).join('');
        return `<sup>${converted}</sup>`;
    });
};

export const formatLocalDate = (date) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export const buildTimeRange = () => {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  const d = now.getDate();
  const q = Math.floor(m / 3) * 3;

  return [
    {
        name: 'All',
        value: {
            start: '',
            end: ''
        }
    },
    {
        name: 'Today',
        value: {
            start: formatLocalDate(new Date(y, m, d)),
            end: formatLocalDate(new Date(y, m, d))
        }
    },
    {
        name: 'This Month',
        value: {
            start: formatLocalDate(new Date(y, m, 1)),
            end: formatLocalDate(new Date(y, m + 1, 0))
        }
    },
    {
        name: 'Last Month',
        value: {
            start: formatLocalDate(new Date(y, m - 1, 1)),
            end: formatLocalDate(new Date(y, m, 0))
        }
    },
    {
        name: 'This Quarter',
        value: {
            start: formatLocalDate(new Date(y, q, 1)),
            end: formatLocalDate(new Date(y, q + 3, 0))
        }
    },
    {
        name: 'This Year',
        value: {
            start: formatLocalDate(new Date(y, 0, 1)),
            end: formatLocalDate(new Date(y, 11, 31))
        }
    },
    {
        name: 'Last Year',
        value: {
            start: formatLocalDate(new Date(y - 1, 0, 1)),
            end: formatLocalDate(new Date(y - 1, 11, 31))
        }
    },
  ];
};

export const convertSuperscriptToPdfMake = (text = '') => {

    const map = {
        '⁰': '0','¹': '1','²': '2','³': '3','⁴': '4',
        '⁵': '5','⁶': '6','⁷': '7','⁸': '8','⁹': '9',
        '⁻': '-','⁺': '+'
    };

    let buffer = '';
    const output = [];

    [...text].forEach(char => {

        if (!map[char]) {
            buffer += char;
            return;
        }

        if (buffer) {
            output.push({ text: buffer });
            buffer = '';
        }

        output.push({
            text: map[char],
            sup: true
        });
    });

    if (buffer) output.push({ text: buffer });

    return output;
};